import { useEffect, useState } from 'react';

import type {
  ExtendedChart,
  ExtendedOptions,
  ExtendedSeriesType
} from '@/components/Chart/types/highcharts';

import type { SelectChangeEvent } from '@mui/material';

const useLegendDropdown = ({
  chart,
  options
}: {
  chart: ExtendedChart | null;
  options: ExtendedOptions | undefined;
}) => {
  const allChartSeries = chart?.series?.filter(series => !series.name.includes('Navigator')) ?? [];

  const [selectedSeries, setSelectedSeries] = useState<ExtendedSeriesType[] | undefined>(undefined);

  // Sync selectedSeries with visible series when options or chart change
  useEffect(() => {
    const all = chart?.series?.filter(series => !series.name.includes('Navigator')) ?? [];
    const visible =
      chart?.series?.filter(series => !series.name.includes('Navigator') && series.visible) ?? [];

    setSelectedSeries(visible.length > 0 ? visible : all);
  }, [options, chart]);

  const handleLegendItemClick = (e: SelectChangeEvent<ExtendedSeriesType[]>) => {
    const value = e.target.value;
    if (typeof value === 'object') {
      chart?.series?.map(item => {
        if (value.includes(item)) {
          item.setVisible(true);
        } else {
          item.setVisible(false);
        }
      });
      const updated = chart?.series?.filter(item => item.visible) ?? [];
      setSelectedSeries(updated);
    }
  };

  const isSeriesDisabled = (series: ExtendedSeriesType) => {
    return selectedSeries?.length === 1 && selectedSeries[0] === series;
  };

  return { selectedSeries, allChartSeries, handleLegendItemClick, isSeriesDisabled };
};

export default useLegendDropdown;
